import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import { Auth0Provider } from "@auth0/auth0-react"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Auth0Provider
    audience="https://real-estate-booking-tm.onrender.com"
    domain="dev-elberx4si3yrfbfm.us.auth0.com"
    clientId="ED3D0N0ocfQ8qS8rdLmxSeC1aQu3jzwj"
    authorizationParams={{
      redirect_uri: "https://real-estate-booking-tm.netlify.app",
    }}
    scope="openid profile email"
  >
    <App />
  </Auth0Provider>
)
